/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetEmployeeConfig200Response
 */
export interface GetEmployeeConfig200Response {
    /**
     * 
     * @type {string}
     * @memberof GetEmployeeConfig200Response
     */
    selectionType: GetEmployeeConfig200ResponseSelectionTypeEnum;
}


/**
 * @export
 */
export const GetEmployeeConfig200ResponseSelectionTypeEnum = {
    Names: 'names',
    Pin: 'pin'
} as const;
export type GetEmployeeConfig200ResponseSelectionTypeEnum = typeof GetEmployeeConfig200ResponseSelectionTypeEnum[keyof typeof GetEmployeeConfig200ResponseSelectionTypeEnum];


/**
 * Check if a given object implements the GetEmployeeConfig200Response interface.
 */
export function instanceOfGetEmployeeConfig200Response(value: object): value is GetEmployeeConfig200Response {
    if (!('selectionType' in value) || value['selectionType'] === undefined) return false;
    return true;
}

export function GetEmployeeConfig200ResponseFromJSON(json: any): GetEmployeeConfig200Response {
    return GetEmployeeConfig200ResponseFromJSONTyped(json, false);
}

export function GetEmployeeConfig200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetEmployeeConfig200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'selectionType': json['selectionType'],
    };
}

export function GetEmployeeConfig200ResponseToJSON(json: any): GetEmployeeConfig200Response {
    return GetEmployeeConfig200ResponseToJSONTyped(json, false);
}

export function GetEmployeeConfig200ResponseToJSONTyped(value?: GetEmployeeConfig200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'selectionType': value['selectionType'],
    };
}

